import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.level,
    props.vip20.level_preset,
    props.vip20.tags,
    props.vip20.xp,
    (level, level_preset, tags, xp) => {
        return {
            level,
            level_preset,
            tags,
            xp
        }
    }
)